import React from 'react';
import { IconButton, Popover, Typography } from '@mui/material';
import * as yup from 'yup';
import {
  SparkDropdown,
  SparkForm,
  SparkFormButton,
  SparkTextField,
} from 'sharedComponents/SparkForm';
import CloseIcon from '@mui/icons-material/Close';
import { DropdownOption } from 'types/common/DropdownOption';

export type SparkReportFormValues = {
  reasonID: string;
  comments: string;
};

type CreateFavouriteListPopUpProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  onSendReport: (values: SparkReportFormValues) => void;
  flagReasonsDropdownOptions: DropdownOption[] | undefined;
  reportType?: 'Spark' | 'Memory';
};
function SparkReport({
  open,
  anchorEl,
  handleClose,
  onSendReport,
  flagReasonsDropdownOptions,
  reportType = 'Spark',
}: CreateFavouriteListPopUpProps) {
  const initialValues = {
    reasonID: '',
    comments: '',
  };
  const validationSchema = yup.object().shape({
    reasonID: yup.string().required('Reason is a required field'),
    comments: yup.string().required('Comments is a required field'),
  });
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClick={(e) => e.stopPropagation()}
      onClose={(e) => {
        //@ts-ignore
        e.stopPropagation();
        handleClose();
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '8px',
          width: 400,
        },
      }}
    >
      <SparkForm<SparkReportFormValues>
        initialValues={initialValues}
        onSave={onSendReport}
        validationSchema={validationSchema}
        sx={{ padding: 2 }}
      >
        <Typography
          variant='h5'
          sx={{
            fontFamily: 'Mont-SemiBold',
            marginLeft: '10px',
            width: '100%',
            pb: 2,
          }}
        >
          Report
        </Typography>
        <SparkDropdown
          name='reasonID'
          label='Reason'
          placeholder={'Reason for reporting this ' + reportType}
          size={12}
        >
          {flagReasonsDropdownOptions || []}
        </SparkDropdown>

        <SparkTextField
          name='comments'
          label='Comments'
          placeholder={'Why are you reporting this ' + reportType}
          multiline={true}
          rows={4}
          size={12}
        />
        <SparkFormButton sx={{ height: '60px', padding: '20px 30px' }}>
          Report {reportType}
        </SparkFormButton>
      </SparkForm>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          zIndex: 100,
          right: 8,
          top: 8,
          color: (theme) => theme.palette.common.black,
        }}
      >
        <CloseIcon />
      </IconButton>
    </Popover>
  );
}

export default SparkReport;
